import { requestWithAuth } from '~/lib/.client/request-with-auth';
import { CLIENT_ORIGIN } from '~/lib/constants';
import type { UserSuggestion } from '~/types/user';
import { invariant } from '~/utils/invariant';

const requestOrganizationWithAuth = requestWithAuth(CLIENT_ORIGIN);

export async function getUsers({ username }: { username: string }) {
  const response = await requestOrganizationWithAuth<{ users: UserSuggestion[] }>(
    `api/users?username=${username}`,
    undefined,
    'GET',
  );

  invariant(response?.users);

  return response.users;
}
